module.exports = __webpack_public_path__ + "img/bg-title.a2d7d80f.png";